import { render, staticRenderFns } from "./IxGeometryErrorLayer.vue?vue&type=template&id=9bb1c786&scoped=true&lang=html&"
import script from "./IxGeometryErrorLayer.vue?vue&type=script&lang=js&"
export * from "./IxGeometryErrorLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb1c786",
  null
  
)

export default component.exports